import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class HomePlayView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    TweenMax.killTweensOf(container)
    TweenMax.set(container, {opacity: 0})
    TweenMax.to(container, .15, {opacity: 1})

    const list = [
      {
        selector: ".festival-name",
        t: .3,
        params: {y: 20, opacity: 0, delay: 0},
        ease: Expo.easeOut,
      },
      {
        selector: ".poster-2",
        t: .4,
        params: {y: 300, delay: .08},
        ease: Expo.easeOut,
      },
      {
        selector: ".poster-1",
        t: .4,
        params: {y: 300, delay: .13},
        ease: Expo.easeOut,
      },
      {
        selector: ".dates-wrapper",
        t: .35,
        params: {y: 30, opacity: 0, delay: .3},
        ease: Sine.easeOut,
      },
      {
        selector: ".edition-footer-right",
        t: .35,
        params: {y: 150, delay: .4},
        ease: Sine.easeOut,
      },
    ]
    list.forEach((obj, index) => {
      const el = container.querySelector(obj.selector)
      if (el) {
        TweenMax.killTweensOf(el)
        TweenMax.from(el, obj.t, obj.params)
      }
    }) 
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    
    const list = [
      {
        selector: ".festival-name",
        t: .3,
        params: {y: 20, opacity: 0, delay: .5},
        ease: Expo.easeIn,
      },
      {
        selector: ".poster-2",
        t: .4,
        params: {y: 300, delay: .4},
        ease: Expo.easeIn,
      },
      {
        selector: ".poster-1",
        t: .4,
        params: {y: 300, delay: .3},
        ease: Expo.easeIn,
      },
      {
        selector: ".dates-wrapper",
        t: .4,
        params: {y: 30, opacity: 0, delay: .15},
        ease: Sine.easeIn,
      },
      {
        selector: ".edition-footer-right",
        t: .4,
        params: {y: 150, delay: 0},
        ease: Sine.easeIn,
      },
    ]
    list.forEach((obj, index) => {
      const el = container.querySelector(obj.selector)
      if (el) {
        TweenMax.killTweensOf(el)
        TweenMax.to(el, obj.t, obj.params)
      }
    })

    TweenMax.killTweensOf(container)
    TweenMax.to(container, .15, {opacity: 0, delay: .65})
    
  }

}

export default HomePlayView